import constants from 'core/types'

export function addLiquidity() {
  return {
    type: constants.ADD_LIQUIDITY
  }
}

